module.exports = __webpack_public_path__ + "static/media/breakdown.a5013ca8.png";